/* istanbul ignore file */
import { array as codecArray, number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { ExtendedJob } from './ExtendedJob';
const JobHistoryJSONParser = /* #__PURE__ */ parsers.object([
    ['notStarted', /* #__PURE__ */ codecArray(ExtendedJob), 'not_started'],
    ['active', /* #__PURE__ */ codecArray(ExtendedJob)],
    ['finished', /* #__PURE__ */ codecArray(ExtendedJob)],
    ['totalFinished', codecNumber, 'total_finished'],
]);
export class JobHistoryJSON extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return JobHistoryJSONParser.decode(input).map(res => new JobHistoryJSON(res));
    }
    static unsafeDecode(input) {
        return JobHistoryJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return JobHistoryJSONParser.encode(data);
    }
    static schema() {
        return JobHistoryJSONParser.schema();
    }
}
